export const errors = {
  first_column_doesnt_have_numbers:
    'Baris pertama file tidak berisi angka, atau file berisi judul kolom.',
  ilegal_symbol_in_number: 'File berisi baris kosong atau format angka tidak valid.',
  number_must_contain_min_max_digits:
    'Nomor telepon harus minimal 5 dan tidak lebih dari 18 digit.',
  too_many_rows: 'Jumlah maksimum baris dalam file telah terlampaui.',
  row: ' (Baris {row})',
  not_found: ' tidak ditemukan',
  field: 'Bidang',
  rule: {
    check_import_file_extension: 'ekstensi file dapat berupa csv, xls, xlsx',
    required: 'bidang wajib diisi',
    file: 'Bidang harus berisi file',
    array: 'bidang harus berupa array',
    maxarray: 'Jumlah catatan terlampaui',
    string: 'bidang harus berupa string',
    integer: 'bidang harus berupa integer',
    maxnumeric: 'nilai tidak boleh lebih besar dari',
    minnumeric: 'nilai tidak boleh kurang dari',
    maxstring: 'nilai tidak boleh lebih besar dari',
    minstring: 'nilai tidak boleh kurang dari',
    regex: 'format tidak valid',
    date_format: 'format tanggal tidak valid'
  },
  recaptcha: 'Ошибка reCAPTCHA',
  general_not_success_request: 'Запрос не может быть выполнен',
  captcha_bad_request: 'Запрос не может быть выполнен. Обратитесь в службу поддержки'
};
